import React from 'react';
import { FieldPath, FieldValues, useController, UseControllerProps } from 'react-hook-form';

import { FormControlLabel, FormControlLabelProps } from '../FormControlLabel/FormControlLabel';
import { Switch, SwitchProps } from '../Switch/Switch';

export interface SwitchFormItemProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
> {
  // -- UseControllerProps -- //
  name: UseControllerProps<TFieldValues, TName>['name'];
  control: UseControllerProps<TFieldValues>['control'];

  // -- FormControlLabelProps -- //
  disabled?: FormControlLabelProps['disabled'];
  label: FormControlLabelProps['label'];
  sx?: FormControlLabelProps['sx'];

  // -- Switch Props -- //
  onChange?: SwitchProps['onChange'];
}

export const SwitchFormItem = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>(
  props: SwitchFormItemProps<TFieldValues, TName>
) => {
  const { name, control, disabled, label, sx, onChange: onChangeFromProps } = props;

  const { field } = useController({
    name,
    control
  });

  const { onChange, value } = field;

  return (
    <FormControlLabel
      control={
        <Switch
          color='primary'
          checked={!!value || false}
          onChange={(e) => {
            const checked = e.target.checked;
            onChange(checked);
            if (onChangeFromProps) onChangeFromProps(e, checked);
          }}
        />
      }
      label={label}
      disabled={disabled}
      sx={sx}
    />
  );
};
